import React, {Fragment, useEffect, useState} from "react";
import {useHistory, useParams} from 'react-router-dom'
import {NaeLayout} from 'nae-react-core-styles'
import {Card} from "react-bootstrap";
import ApiRest from "../../../service/ApiRest";
import ServiceForm from "../../Forms/ServiceForm";
import {toast} from "react-toastify";
import InvoiceLinesListCard from "../Invoices/InvoiceLinesListCard";

const moduleName = 'service';

interface ParamTypes {
    id: string
}

const defElement = {
    id: 0,
    name: '',
    fvsCode: '',
    reverseVat: false,
    fvsSeparateLine: false,
    skipReports: false,
    serviceGroup: 0,
    serviceGroupName: '',
}


export default function ServicesPage() {
    const history = useHistory();

    const [element, setElement] = useState(defElement);
    const {id} = useParams<ParamTypes>();
    const saveData = (name: string,
                      fvsCode: string,
                      reverseVat: boolean,
                      fvsSeparateLine: boolean,
                      skipReports: boolean,
                      serviceGroup: number,
    ) => {
        if (id === 'new') {
            ApiRest.addElement(
                moduleName,
                {
                    name,
                    fvsCode,
                    reverseVat,
                    fvsSeparateLine,
                    skipReports,
                    serviceGroup
                }
            ).then(res => {
                toast.success('Įrašas išsaugotas');
                setElement(res);
                history.push('/' + moduleName + '/' + res.id);
            })
        } else {
            ApiRest.updateElement(
                moduleName,
                element.id,
                {
                    name,
                    fvsCode,
                    reverseVat,
                    fvsSeparateLine,
                    skipReports,
                    serviceGroup
                }
            ).then(res => {
                toast.success('Įrašas išsaugotas');
                setElement(res);
            });
        }
    }

    const getData = () => {
        if (id !== 'new') {
            ApiRest.getElement(moduleName, parseInt(id, 10)).then(res => {
                setElement(res);
            }).catch(e => {

            });
        }
    }

    useEffect(getData, [id]);

    const form = (element.id > 0 || id === 'new') ?
        <Fragment>
            <ServiceForm element={element} saveData={saveData}/>
        </Fragment>
        : <Fragment/>
    ;

    const rightComponent = (
        <Fragment/>
    );

    return (<Fragment>

            <NaeLayout.NaePageViewLayout leftComponent={form} rightComponent={rightComponent}/>

            {element.id > 0 &&
            <InvoiceLinesListCard options={{serviceId: element.id}}/>
            }

        </Fragment>
    )
}
